import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { DndDropEvent, DndModule } from 'ngx-drag-drop';
import { Question } from '../../../models/QuestionResponse';

@Component({
  selector: 'q-jeufleche',
  standalone: true,
  imports: [CommonModule, DndModule],
  templateUrl: './jeufleche.component.html',
  styleUrl: './jeufleche.component.scss',
})
export class JeuflecheComponent {
  @Input() question!: Question;
  @Input() pickedAnswers!: string[];
  @Output() pickedAnswersChange = new EventEmitter<string[]>();

  possibleChoices: string[] = [];
  answers: string[] = [];
  answerGreen: boolean[] = [];
  draggingAnswer: string | null = null;
  animatingAnswers: Set<string> = new Set();

  ngOnInit() {
    this.setupQuestion();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['question']) {
      this.setupQuestion();
    }
  }

  setupQuestion() {
    let array: string[] = [];
    let green: boolean[] = [];

    this.question.good_answers.forEach((elt, index) => {
      if (!array.includes(elt)) {
        array.push(elt);
        green.push(this.question.is_green[index]);
      }
    });

    this.possibleChoices = array;
    this.answerGreen = green;
    this.answers = [...this.question.answers];
  }

  getPossibilitesFor(choice: string): string[] {
    let array: string[] = [];

    for (let i = 0; i < this.question.answers.length; i++) {
      if (this.pickedAnswers[i] === choice) {
        array.push(this.question.answers[i]);
      }
    }

    return array;
  }

  onDrop(event: DndDropEvent, choice: string) {
    let originalIndex = this.question.answers.findIndex((elt) => elt === event.data);
    if (originalIndex !== -1) {
      this.pickedAnswers[originalIndex] = choice;
      this.pickedAnswersChange.emit(this.pickedAnswers);
    }

    if (choice === '') {
      if (this.answers.findIndex((elt) => elt === event.data) === -1) {
        this.answers.push(event.data);
      }
    } else {
      let index = this.answers.findIndex((elt) => elt === event.data);
      if (index !== -1) {
        this.answers.splice(index, 1);
      }

      // Déclencher l'animation pour la réponse droppée dans un answerContainer
      this.animatingAnswers.add(event.data);
      setTimeout(() => {
        this.animatingAnswers.delete(event.data);
      }, 150);
    }
    this.draggingAnswer = null;
  }

  onDragStart(event: DragEvent, answer: string) {
    this.draggingAnswer = answer;
  }

  onDragCanceled(event: DragEvent) {
    this.draggingAnswer = null;
  }

  getStyleForAnswer(answer: string): any {
    if (this.draggingAnswer === null) {
      return {};
    } else if (this.draggingAnswer === answer) {
      return {
        display: 'none',
      };
    }

    return {};
  }

  isAnimating(answer: string): boolean {
    return this.animatingAnswers.has(answer);
  }
}
